import { Card, Row, Col, Divider, Modal } from 'antd';
import { RegistrationCode422Modal } from '@bit/ui-common.ui-components/ss-components';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { setEnvPrefix } = ssCommonUtils;

export default class Welcome extends React.Component {
    constructor(props) { super(props); }
    render() {
        const
        { candidate, services, captcha, registrationForm, passwordReset } = this.props,
        { showPasswordResetModal } = candidate,
        reset = () => {
            services.toggleModalPasswordResetRequest();
            services.resetCaptchaValidation();
            services.clearRequestPasswordReset();
        };

        return (
            <div>
                <Modal
                    visible={showPasswordResetModal}
                    centered={true}
                    footer={null}
                    closable={false}
                    width={0}
                >
                    <RegistrationCode422Modal data={{
                        altClass: true,
                        captcha,
                        showPasswordResetModal,
                        toggleModalPasswordResetRequest: () => services.toggleModalPasswordResetRequest(),
                        passwordResetRequest: passwordReset.request,
                        form: registrationForm,
                        storeForm: services.storeForm,
                        storeFormField: services.storeFormField,
                        captchaServices: {
                            validateCaptcha: services.validateCaptcha,
                            updateCaptchaField: services.updateCaptchaField,
                            loadCaptcha: services.loadCaptcha,
                            resetCaptchaValidation: services.resetCaptchaValidation
                        },
                        modalOnClick: () => reset(),
                        submitPasswordReset: field => services.requestPasswordReset(field, captcha.field),
                        onResetSuccess: () => {
                            reset();
                            window.location.href = setEnvPrefix('/home');
                        },
                        onResetFailure: () => reset()
                    }} />
                </Modal>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={15}>
                        <Card hoverable style={{ cursor: 'default' }} bodyStyle={{ lineHeight: '18px' }}>
                            <Divider style={{ margin: '0px 0px 20px' }}>
                                <div style={{ textAlign: 'center', fontSize: '14px', fontWeight: 'bold', fontStyle: 'italic' }}>
                                    <span style={{ color: 'rgb(53, 158, 255)' }}>
                                        {'Welcome to the Flight Training Security Program!'}
                                    </span>
                                </div>
                            </Divider>
                            <div>
                                {' You are beginning the process of creating a '} <b> {'Candidate'} </b> {' account on the Flight Training ' +
                                'Security Program (FTSP) online portal. Please make sure you have the following information ' +
                                'ready, to make creating your account as easy as possible: '}
                            </div>
                            <ul style={{ marginTop: '28px' }}>
                                <li>{'Current, valid, Government-issued identification documents (typically passport and visa); and'}</li>
                                <li>
                                  {'A valid personal email address (required). TSA will send your user login ID, password, and '}
                                  {'other communications to this address.'}
                                </li>
                            </ul>
                            <div style={{ marginTop: '30px' }}>
                                {'If you have previously created an account, but have forgotten your password, please click '}
                                <div
                                    className='registration-password-reset-help-text'
                                    onClick={() => services.toggleModalPasswordResetRequest()}
                                >{'here'}</div>
                                {' to have your login information emailed to you. DO NOT attempt to create a '}
                                {'new account, as this may delay the processing of your security threat assessment or training '}
                                {'event notification(s).'}
                            </div>
                            <div style={{ marginTop: '32px' }}>
                                {'If you have questions or concerns, please contact us at '}
                                <a href="mailto:FTSP.Help@dhs.gov">{'FTSP.Help@tsa.dhs.gov'}</a>
                                {'. (Allow at least 5 business days for a response.)'}
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}
